export default "__VITE_ASSET__DLkeX7Yi__"